<mat-toolbar color="primary" class="mat-elevation-z4">
  <button mat-button routerLink="/management/offices">
    <mat-icon>arrow_back</mat-icon>
    Back to Offices
  </button>
  <span class="toolbar-title">Office: {{ officeId }}</span>
</mat-toolbar>

<div class="content-container">
  ``
  <h1 class="page-title">Paypoints & Routing</h1>
  <p class="page-subtitle">Configure payment processing and routing rules for this office.</p>

  <div class="grid-container">
    <!-- Left Column: Paypoints & Routing Rules -->
    <div class="left-column">
      <!-- Paypoints Card -->
      <kt-bridgepay-view-paypoints
        *ngIf="!enableAddPaypoint"
        [paypoints]="paypoints"
        (addPaypoint)="onAddPaypoint()"
      ></kt-bridgepay-view-paypoints>
      <kt-bridgepay-add-paypoint
        *ngIf="enableAddPaypoint"
        [organization]="organization"
        [officeId]="officeId"
        (addPaypoint)="onPaypointAdded()"
      ></kt-bridgepay-add-paypoint>

      <!-- Routing Rules Card -->
      <kt-bridgepay-view-routing-rules
        *ngIf="!enableAddRule"
        [routingRules]="routingRules"
        (addRule)="onAddRule()"
      ></kt-bridgepay-view-routing-rules>
      <kt-bridgepay-add-routing-rule
        *ngIf="enableAddRule"
        [paypoints]="paypoints"
        [organization]="organization"
        [officeId]="officeId"
        (addRule)="onRuleAdded()"
      ></kt-bridgepay-add-routing-rule>
    </div>

    <!-- Right Column: Preview & Validation -->
    <div class="right-column">
      <!-- Routing Preview Card -->
      <mat-card class="card-section">
        <mat-card-header>
          <mat-card-title>Routing Preview</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="preview-flow">
            <div class="flow-item" *ngFor="let rule of routingRules">
              <div class="flow-label">{{ rule.label }}</div>
              <mat-icon>arrow_forward</mat-icon>
              <div class="flow-target">{{ rule.target.provider }}</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Validation Messages Card -->
      <mat-card class="card-section">
        <mat-card-header>
          <mat-card-title>Validation Messages</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div
            class="validation-message"
            *ngFor="let msg of validationMessages"
            [ngClass]="{ success: msg.type === 'success', warning: msg.type === 'warning' }"
          >
            <mat-icon *ngIf="msg.type === 'success'">check_circle</mat-icon>
            <mat-icon *ngIf="msg.type === 'warning'">error_outline</mat-icon>
            <span>{{ msg.message }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
